import { useCallback } from "react";
import { useDocumentSharing } from "./usedocumentsharing";

export function useSharingExpiration() {
  const { extendAccess, extendLoading, extendError } = useDocumentSharing();

  const applyExpirationToSharedDocuments = useCallback(
    async ({ documentIds = [], doctorIds = [], expiresInHours }) => {
      if (!documentIds.length || !doctorIds.length || expiresInHours == null) {
        return { total: 0, success: 0, failed: 0, failures: [] };
      }

      const jobs = [];
      documentIds.forEach((documentId) => {
        doctorIds.forEach((doctorId) => {
          jobs.push({ documentId, doctorId });
        });
      });

      const results = await Promise.allSettled(
        jobs.map((job) =>
          extendAccess({
            documentId: job.documentId,
            doctorId: job.doctorId,
            expiresInHours,
          }).unwrap()
        )
      );

      const failures = results
        .map((result, index) => ({ result, job: jobs[index] }))
        .filter((item) => item.result.status === "rejected")
        .map((item) => ({ ...item.job, error: item.result.reason }));

      return {
        total: jobs.length,
        success: jobs.length - failures.length,
        failed: failures.length,
        failures,
      };
    },
    [extendAccess]
  );

  return {
    applyExpirationToSharedDocuments,
    extendLoading,
    extendError,
  };
}

export default useSharingExpiration;
